import { IgButton } from "@intelligems/ig-theme/IgButton";
import { Dialog } from "@mui/material";
import { ProductPicker } from "@src/components/MainApp/SharedProductPicker/ProductPicker";
import { useDispatch, useSelector } from "@src/store";
import { closeProductPicker } from "@src/store/slices/productPicker";
import { isProductPickerOpen } from "@src/store/slices/productPicker/selectors/isProductPickerOpen";
import { isValidProductPickerSelection } from "@src/store/slices/productPicker/selectors/isValidProductPickerSelection";
import { saveOnsiteUpsellProductPicker } from "@src/store/slices/productPicker/thunks/onsiteUpsell/saveOnsiteUpsellProductPicker";

// Shared product picker for the onsite-upsell config panel (THEN action, cart
// variant condition, PDP product condition). The panel's open thunks route the
// selection; `saveOnsiteUpsellProductPicker` writes it back to the draft.
export const OnsiteUpsellProductPickerDialog = () => {
  const dispatch = useDispatch();
  const actionOpen = useSelector(isProductPickerOpen("onsiteUpsellAction"));
  const cartOpen = useSelector(isProductPickerOpen("onsiteUpsellCartVariants"));
  const pdpProductsOpen = useSelector(
    isProductPickerOpen("onsiteUpsellPdpProducts")
  );
  const isValidSelection = useSelector(isValidProductPickerSelection);

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      open={actionOpen || cartOpen || pdpProductsOpen}
      sx={{ zIndex: 1401 }}
      onClose={() => dispatch(closeProductPicker())}
      slotProps={{ paper: { style: { maxHeight: "700px" } } }}
    >
      <ProductPicker
        loadVariants={!pdpProductsOpen}
        dialogActions={[
          <IgButton
            key="cancel"
            variant="text"
            onClick={() => dispatch(closeProductPicker())}
          >
            Cancel
          </IgButton>,
          <IgButton
            key="save"
            variant="contained"
            onClick={() => void dispatch(saveOnsiteUpsellProductPicker())}
            disabled={!isValidSelection}
          >
            {cartOpen ? "Add variants" : "Add products"}
          </IgButton>,
        ]}
      />
    </Dialog>
  );
};
